import http from '@/http/aisea/axios'
const resource = "/secure_dataflow/enterprise/vessels";

export default {
  // チャンネルバージョンAPIのURLや必要なパラメータ設定箇所
  getChannelVersions(vesselId, params){
    return http.get(`${resource}/${vesselId}/channel_versions/`, {
      params: params
    });
  },
  // チャンネルマスタAPIのURLや必要なパラメータ設定箇所
  getChannels(vesselId, params) {
    return http.get(`${resource}/${vesselId}/channels/`, {
      params: params
    })
  }
}